import type {EmailMakerControlProps} from '../../right-panel-registry.types';

export interface StyleHeaderInnerProps extends EmailMakerControlProps {
  labelKey: string;
  withTopMargin: boolean;
}

export const STYLE_HEADER_DEFAULT_TOP_MARGIN = true;
